<template>
    <van-nav-bar
        title="客户信息查询"
        left-text="返回"
        left-arrow
        @click-left="onClickLeft"
    />
    <div style="width: 97%;margin: 0 auto;margin-top: 20px">
        <van-search v-model="Search" placeholder="公司名/操作人" @search="onSearch" />
        <div style="width: 97%;margin: 0 auto;margin-top: 20px">
            <div v-for="(val,index) in Query_List" :key="val">
                <van-swipe-cell>
                    <van-cell :value="val.date" is-link :to="{ name: 'CustomerRevise',query:{ id:val.id }}" icon="manager-o" >
                        <!-- 使用 title 插槽来自定义标题 -->
                        <template #title>
                            <span class="custom-title" >{{ val.id+' - '+val.customer_Name }}</span>
                            <van-tag type="primary" style="left: 10px">{{ val.prepared_By }}</van-tag>
                            <van-tag type="warning" style="left: 20px" v-if="val.state == 'Y'">已作废</van-tag>
                        </template>
                    </van-cell>
                    <template #right >
                        <van-button square type="warning" text="作废" @click="Void(val.id,index)" v-if="val.state == 'N'" />
                        <van-button square type="warning" disabled  text="作废" v-else />
                    </template>
                </van-swipe-cell>
            </div>
        </div>
    </div>
</template>

<script setup>
import {ref} from "vue";
import axios from "axios";
import {showConfirmDialog, showFailToast, showSuccessToast} from "vant";

const onClickLeft = () => history.back();
const Search = ref();
const Query_List = ref([]);
// const customer_name = ref('');
// const prepared_By = ref('');
// const date = ref('');

const onSearch = (val) =>{
    //axios.post("http://localhost:8002/lj/back/query_customer",
    axios.post("https://afa.activa-leisure.com/lj/back/query_customer",
    {Search: val},
    {
        headers:{
            "content-type": "application/x-www-form-urlencoded"
        }
    }).then( result => {
        if (result.data.success){
            Query_List.value = result.data.data;
        }else {
            showFailToast(result.data.message)
        }
    })
}

const Void = (id,index) => {
    console.log(id)
    showConfirmDialog({
        title: '客户作废',
        message: '确定要作废此客户信息单据吗？',
    })
    .then(() => {
         //axios.post("http://localhost:8002/lj/back/void_customer",
        axios.post("https://afa.activa-leisure.com/lj/back/void_customer",
            {id: id},
            {
                headers:{
                    "content-type": "application/x-www-form-urlencoded"
                }
            }).then( result => {
                if (result.data.success){
                    Query_List.value[index].state = 'Y'
                    showSuccessToast(result.data.message);
                }else {
                    showFailToast(result.data.message)
                }
            })

    })
    .catch(() => {
        // on cancel
    });
}
</script>

<style scoped>

</style>